import { render, staticRenderFns } from "./NewPerfildeUsuario.vue?vue&type=template&id=e646e1f0&scoped=true&"
import script from "./NewPerfildeUsuario.vue?vue&type=script&lang=ts&"
export * from "./NewPerfildeUsuario.vue?vue&type=script&lang=ts&"
import style0 from "./NewPerfildeUsuario.vue?vue&type=style&index=0&id=e646e1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e646e1f0",
  null
  
)

export default component.exports